<template>
	<neu-cards-slider2 cols=3 class="pt-lg-5 pt-0 mt-0 my-md-5 position-relative" :cards="_swipperContent" :blackTitle="title"></neu-cards-slider2>
	<!-- <div class="swiper-page">
		<div class="wrap-swiper-content">
				<h4 class="swiper-title-content">{{ $t('patients-swiper.care-your-health') }}</h4>
				<div class="custom-swiper-buttons">
						<div class="swiper-button-next"></div>
						<div class="swiper-button-prev"></div>
				</div>
				<div class="mySwiper">
						<div class="swiper-wrapper"></div>
						<div class="swiper-pagination"></div>

				</div>
				<div class="wrap-buttons center">
						<button class="item-button black-lineal" @click="() => { $router.push('/inicio-sesion')} "><a>{{ $t('patients-swiper.sign-up-free') }}</a></button>
				</div>
		</div>
	</div> -->
</template>

<script>
/* eslint-disable */
/* import { loadScript } from 'vue-plugin-load-script'
import Swiper, { Navigation } from 'swiper'
import 'swiper/swiper-bundle.min.css' // core Swiper
import 'swiper/modules/navigation/navigation.min.css' // Navigation module
import 'swiper/modules/pagination/pagination.min.css' // Pagination module */
import NeuCardsSlider2 from '@/components/base/ui/NeuCardsSlider2.vue'

/* const SWIPER_SCRIPT_URL = 'https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.js' */

export default {
	components: {
		NeuCardsSlider2
	},
	props: {
		title: {
			type: String
		}
	},
	computed: {
		_swipperContent () {
			return this.swipperContent.map((content, index) => ({
				src: content.src,
				title: content.title,
				type: 0
			}))
		}
	},
	data () {
		return {
			userInteracted: false,
			lastSlideIndex: -1,
			swipperContent: [
			{
				src: '/static-appopensalud/img/icons/morillas-svg-icons/primary/cloud-services.svg',
				title: this.$t('patients-swiper.cloud-clinic-history')
			},
			{
				src: '/static-appopensalud/img/icons/morillas-svg-icons/primary/test-services.svg',
				title: this.$t('patients-swiper.rate-your-health')
			},
			{
				src: '/static-appopensalud/img/icons/morillas-svg-icons/primary/habits-services.svg',
				title: this.$t('patients-swiper.habit-tracker')
			},
			{
				src: '/static-appopensalud/img/icons/morillas-svg-icons/primary/health-food-services.svg',
				title: this.$t('patients-swiper.healthy-foods')
			},
			{
				src: '/static-appopensalud/img/icons/morillas-svg-icons/primary/menstrual-cycle.svg',
				title: this.$t('patients-swiper.menstrual-cycle')
			},
			{
				src: '/static-appopensalud/img/icons/morillas-svg-icons/primary/forum-services.svg',
				title: this.$t('patients-swiper.patients-like-you')
			},
			{
				src: '/static-appopensalud/img/icons/morillas-svg-icons/primary/habitos.svg',
				title: this.$t('patients-swiper.habits-that-care')
			},
			{
				src: '/static-appopensalud/img/icons/morillas-svg-icons/primary/monitor-variables.svg',
				title: this.$t('patients-swiper.device-connection')
			},
			{
				src: '/static-appopensalud/img/icons/morillas-svg-icons/primary/blog-services.svg',
				title: this.$t('patients-swiper.health-blog')
			},
			{
				src: '/static-appopensalud/img/icons/morillas-svg-icons/primary/notices-services.svg',
				title: this.$t('patients-swiper.reminders')
			}
		]
		}
	},
	/* mounted () {
		const _this = this

		const swiper = new Swiper('.mySwiper', {
			on: {
				slideChange: function () {
					if (this.realIndex !== _this.lastSlideIndex && _this.userInteracted) {
						_this.lastSlideIndex = this.realIndex

						window.dataLayer = window.dataLayer || []
						window.dataLayer.push({
							'event': 'slideChange'
						})
					}
				},
				touchStart: function () {
					_this.userInteracted = true
				},
				touchEnd: function () {
					_this.userInteracted = false
				}
			},

			outerWidth: '',
			effect: 'coverflow',
			grabCursor: true,
			centeredSlides: true,
			slidesPerView: 1,
			spaceBetween: 30,
			coverflowEffect: {
				rotate: 30,
				stretch: 160,
				depth: 500,
				modifier: 1,
				slideShadows: false
			},
			modules: [Navigation],
			navigation:{
				nextEl:'.custom-swiper-buttons .swiper-button-next',
				prevEl:'.custom-swiper-buttons .swiper-button-prev',
			},
			// Permitir desplazamiento hacia la izquierda
			loop: true,
			// Para pantallas mayores de 1024px
			breakpoints: {
				769: {
					effect: 'coverflow',
					centeredSlides: true,
					slidesPerView: '1',
					spaceBetween: 30,
					coverflowEffect: {
						rotate: 30,
						stretch: 450,
						depth: 500,
						modifier: 1,
						slideShadows: false
					}
				},
				1024: {
					centeredSlides: false,
					slidesPerView: '3',
					spaceBetween: 10,
					coverflowEffect: {
						rotate: 0,
						stretch: 0,
						depth: 0,
						modifier: 1,
						slideShadows: false
					}
				}
			}
		})

		var swiperWrapper = document.querySelector('.swiper-wrapper')
		for (var i = 0; i < this.swipperContent.length; i++) {
			swiperWrapper.innerHTML += `
			<article class="swiper-slide">
				<div class="swiper-card">
					<img class="swiper-icon" src="${this.swipperContent[i].icon}">
					<h4 class="swiper-title">${this.swipperContent[i].title}</h4>
				</div>
			</article>
			`
		}
	} */
}
</script>

<style lang="scss">

.neu-card-general {
    background-color: $white;
}

	/*PAGE*/
.page-hero{
    display: block;
    width: 100%;
    height: 100vh;
    position: relative;
    top: 0;
    bottom: 0;
    background:#E4E4E4;
}
.main-imagen-background{
    width: 100%;
    height: 100vh;
    position: static;
}
.main-content-page{
    display: flex;
    width: 50%;
    position: absolute;
    top: 0px;
    bottom: 0;
}
.wrap-main-content{
    display: flex;
    flex-direction: column;
    padding: 8rem 10rem;
    margin-top: 2rem;
    width: 100%;
    justify-content: center;
}

.right-imagen-background{
    width: 50%;
    height: 100vh;
    position: absolute;
    left: 50%;
}
.left-imagen-background{
    width: 50%;
    height: 100vh;
    position: absolute;
    left: 0%;
}


    /* image background */
    #patients{
        background-image: url("/static-appopensalud/img/bgs/opt/oceano.webp");
        background-position: center;
        background-size: cover;
        background-repeat: no-repeat;
    }


.page{
    display: flex;
    width: 100%;
    /* min-height: 80vh; */
    background:#E4E4E4;
}

.page.menttum{
    align-items: center;
}

.swiper-page{
    display: flex;
    width: 100%;
    height: auto;
    background: #E4E4E4;
}
.content-page{
    width: 50%;
}
.content-page.full{
    width: 100%;
}
.wrap-content {
    margin: 8rem 0rem;
    padding: 3rem 10rem;
}
.wrap-content.full {
    margin: 0rem 0rem 8rem 0rem;
    padding: 3rem 10rem;
}


    /* image background */
    #black, .black {
        background-color: #1d1d1d;
    }
    #heart{
        background-image: url("/static-appopensalud/img/icons/morillas-svg-icons/primary/NEU_BigHeart.svg");
        background-position: center;
        background-size: contain;
        background-repeat: no-repeat;
				-webkit-background-size: cover;
        -webkit-background-position: right;
        -webkit-background-repeat: no-repeat;
    }
    #profesional{
        background-image: url("/static-appopensalud/img/bgs/opt/profesionales15-6.jpg");
        background-position: right;
        background-size: cover;
        background-repeat: no-repeat;
        -webkit-background-size: cover;
        -webkit-background-position: right;
        -webkit-background-repeat: no-repeat;

				@include mobile {
					height: 40vh;
					@supports (height: 40dvh) {
						height: 40dvh;
					}
				}
    }
		#menttum {
			background-image: url("/static-appopensalud/img/bgs/calm-background.jpg");
			background-size: cover;
			background-repeat: no-repeat;
			-webkit-background-size: cover;
			-webkit-background-repeat: no-repeat;

			@include mobile {
				height: 40vh;
				@supports (height: 40dvh) {
					height: 40dvh;
				}
			}
		}

		#lake {
			background-image: url("/static-appopensalud/img/bgs/calm-background.jpg");
			background-size: cover;
			background-repeat: no-repeat;
			-webkit-background-size: cover;
			-webkit-background-repeat: no-repeat;

			@include mobile {
				height: 40vh;
				@supports (height: 40dvh) {
					height: 40dvh;
				}
			}
		}


@media only screen and (min-width: 1396px) and (max-width: 1705px) and (min-height: 632px) and (max-height: 772px){      
    .main-content-page{width: 55%;}
    .wrap-main-content {padding: 0rem 10rem 4rem 10rem; justify-content: center;}

    .wrap-content{margin:6rem 0rem;}
    .wrap-content.full {margin: 0rem 0rem 4rem 0rem;}

        #forall{background-position: center;}
}


@media only screen and (max-width: 768px) {
    .page-hero{
			height: 100vh;
			@supports (height: 100dvh) {
				height: 100dvh;
			}
			display: flex; 
			flex-direction: column;
		}
    .main-imagen-background{height: 45%;z-index: 998;}    
    .main-content-page{width: 100%; height:50%; position:static;}
    .wrap-main-content{padding: 2rem; margin-top:1rem;}
    .right-imagen-background{width:100%; height: 45%; left: 0;}
    .left-imagen-background{height: 45vh;}
        
        #business{background-position: -150px;}

    .page{flex-direction: column; min-height: auto;}
    .page.forall{flex-direction: column-reverse;}
    .content-page{width: 100%;}
    .wrap-content{padding: 2rem 2rem; margin: 1rem 0rem;}
    .wrap-content.menttum{padding: 2rem 2rem; margin:-6rem 0rem 4rem 0rem;}
    .wrap-content.full{margin: 0rem; padding: 2rem;}

        #forall{height: 50vh;background-position: center;}
}


@media only screen and (min-width: 769px) and (max-width: 1024px){
	.page-hero{
			height: 100vh;
			@supports (height: 100dvh) {
				height: 100dvh;
			}
			display: flex; 
			flex-direction: column;
		}
    .main-imagen-background{height: 45%;z-index: 998;}  
    .main-content-page{width: 100%; height:50%; position:static;}
    .wrap-main-content{padding: 6rem; margin-top:1rem;}
    .right-imagen-background{width:100%; height: 45%; left: 0;}
    .left-imagen-background{height: 45vh;}

        #business{background-position-x: center;}


    .page{flex-direction: column; min-height: auto;}
    .page.forall{flex-direction: column-reverse;}
    .content-page{width: 100%;}
    .wrap-content{padding: 6rem 6rem; margin: 2rem 0rem;}
    .wrap-content.menttum{padding: 2rem 2rem; margin:-6rem 0rem 4rem 0rem;}
    .wrap-content.full{margin: 0rem; padding: 6rem;}

        #forall{height: 50vh;}
}


@media only screen and (max-height: 600px) and (orientation: landscape){
	.page-hero{
			height: 150vh;
			@supports (height: 150dvh) {
				height: 150dvh;
			}
			display: flex; 
			flex-direction: column;
		}
    .main-imagen-background{height: 100%;z-index: 998;}
    .main-content-page{width: 100%; height:auto;}
    .wrap-main-content{padding: 2rem; margin-top:1rem; justify-content: center; align-items: center;} 
}

/* tablet landscape */
@media only screen and (min-width: 1024px) and (max-width: 1366px) and (min-height: 600px) and (max-height: 1024px){
	.page-hero{
			height: 100vh;
			@supports (height: 100dvh) {
				height: 100dvh;
			}
			display: flex; 
			flex-direction: column;
		}
    .wrap-main-content{justify-content: center; align-items: unset; padding: 1rem 4rem 1rem 10rem;}

    .wrap-content{padding: 6rem 6rem; margin: 2rem 0rem;}
    .wrap-content.full{margin: 0rem; padding: 2rem 6rem;}

    #forall {background-position: center;}
}



/*CONTENT*/

.main-title {
    font-size: 42px;
    font-weight: 400;
    line-height: 1.2;
    margin-bottom: 3rem;
    color: #1D1D1E;
}
.main-subtitle {
    font-size: 22px;
    font-weight: 600;
    line-height: 1.2;
    letter-spacing: .2px;
    margin-bottom: 1rem;
    color: #3238c4;
}
.main-paragraph {
    font-size: 17px;
    font-weight: 400;
    line-height: 1.2;
    letter-spacing: .2px;
    margin-bottom: 2rem;
    color: #1D1D1E;
}
.title{
    font-weight: 500;
    line-height: 1.2;
    letter-spacing: .2px;
    margin-bottom: 3rem;
    color: #1D1D1E;
}
.subtitle{
    font-size: 22px;
    font-weight: 600;
    line-height: 1.2;
    letter-spacing: .2px;
    margin-bottom: 1rem;
    color: #3238c4;
}
.paragraph{
    font-size: 17px;
    font-weight: 400;
    line-height: 1.6;
    letter-spacing: .2px;
    margin-bottom: 5rem;
    color: #1D1D1E;
}
.center{text-align: center;}
.end.paragraph{margin-bottom: unset;}


.wrap-paragraph{
    display: flex;
    flex-direction: row;
}
.paragraph-x2{
    display: flex;
    flex-direction: column;
    flex: 0 0 calc(50% - 20px);
    margin: 0% 5% 0% 0%;
}

.title.white{color: #eee;}
.subtitle.white {color: #eee;}
.paragraph.grey{color: #8A8A8A;}


/*Botones*/
.wrap-buttons{
    display: flex;
    margin-top: 1rem;
}
.wrap-buttons.center{
    justify-content: center;
}
.first-button {
    margin-right: 3.5rem;
}
.item-button {
    font-size: 13px;
    font-weight: bold;
    line-height: 1.6;
    border-radius: 28px;
    padding: 0.7rem 2.2rem;
    align-items: center;
    white-space: nowrap;
		text-transform: uppercase;
}
.item-button.grey-lineal {
    border: 1px solid #979797;
    color: #979797;
		transition: all 0.3s ease;
}

button.grey-lineal:hover {
	background-color: #979797;
	color: #fff;
	transition: all 0.3s ease;


}

.item-button.white-solid {
    border: 1px solid white;
    background-color: white;
    color: #3238C4;
    box-shadow: -10px -10px 35px #fff, 10px 10px 35px rgba(13,39,80,0.160784);
}
.item-button.white-solid:hover {
    border: 1px solid #3238C4;
}
.item-button.black-lineal {
    border: 1px solid #1d1d1d;
    color: #1d1d1d;
}

.item-button.white-lineal {
    border: 1.5px solid  #eee;
    color:  #eee;
		background-color: transparent;
}

@media only screen and (min-width: 1396px) and (max-width: 1705px) and (min-height: 632px) and (max-height: 772px){
    .main-title{font-size: 36px; font-weight: 400; margin-bottom: 3rem;}
    .main-subtitle{margin-bottom: 1rem;}
    .main-paragraph{margin-bottom: 2rem;}
    .title{margin-bottom: 3rem;}
    .subtitle{margin-bottom: 1rem;}
    .paragraph{margin-bottom: 5rem;}
    .end.paragraph{margin-bottom: unset;}
}


@media only screen and (max-width: 768px) {
    .main-title{font-size: 27px; margin-bottom: 2rem}
    .main-subtitle{font-size: 16px;}
    .main-paragraph{font-size: 15px; margin-bottom: 1rem;}
    .title{font-size: 23px; margin-bottom:2rem}
    .subtitle{font-size: 16px; margin-bottom: 1rem;}
    .paragraph{font-size: 15px; margin-bottom: 3rem;}

    .wrap-paragraph{flex-direction: column;}

    .wrap-buttons{flex-wrap: wrap;}
    .first-button{margin-right: 2rem;}
    .first-button, .second-button{margin-bottom: 1rem;}
    .item-button{font-size: 10px;}
}

@media only screen and (min-width: 769px) and (max-width: 1024px){
    .main-title{font-size: 32px; margin-bottom: 2rem}
    .main-subtitle{font-size: 16px;}
    .main-paragraph{font-size: 15px; margin-bottom: 3rem;}
    .title{font-size: 32px; margin-bottom: 2rem}
    .subtitle{font-size: 16px;}
    .paragraph{font-size: 15px; margin-bottom: 3rem;}

    .wrap-paragraph{flex-direction: column;}

    .wrap-buttons{flex-wrap: wrap;}
    .first-button{margin-right: 2rem;}
    .first-button, .second-button{margin-bottom: 2rem;}
    .item-button{font-size: 10px;}
}

/*tablet landscape*/
@media only screen and (min-width: 1024px) and (max-width: 1366px) and (min-height: 600px) and (max-height: 1024px){
    .main-title{font-size: 32px; margin-bottom: 2rem}
    .main-subtitle{font-size: 16px;}
    .main-paragraph{font-size: 15px; margin-bottom: 3rem;}
    .title{font-size: 32px; margin-bottom: 2rem}
    .subtitle{font-size: 16px;}
    .paragraph{font-size: 15px; margin-bottom: 3rem;}

    .wrap-paragraph{flex-direction: row;}

    .wrap-buttons{flex-wrap: wrap;}
    .first-button{margin-right: 2rem;}
    .first-button, .second-button{margin-bottom: 2rem;}
    .item-button{font-size: 10px;}
}





/*swiper*/
.swiper-page {
    display: flex;
    width: 100%;
    height: auto;
    background: #E4E4E4;
}
.wrap-swiper-content{
    display: flex;
    width: 100%;
    flex-direction: column;
    padding: 4rem 0rem;
    margin: 4rem 0rem 0rem 0rem;
}
.swiper-title-content{    
    font-size: 42px;
    font-weight: 400;
    line-height: 1.2;
    letter-spacing: .2px;
    color: #1D1D1E;
    text-align: center;
    margin: 0 10rem 3rem 10rem;
}
.swiper-subtitle-content{
    font-size: 22px;
    font-weight: 600;
    line-height: 1.2;
    letter-spacing: .2px;
    color: #3238c4;
    text-align: center;
    margin: 0 10rem 5rem 10rem;
}
.mySwiper {
    overflow: hidden;
    text-align: -webkit-center;
    margin: 0 10rem 5rem 10rem;
    z-index: 997;
}
.swiper-wrapper {
    margin: 2rem 0rem;
}
.swiper-card {
    display: flex;
    flex-direction: column;
    justify-content: center;
    width: 90%;
    min-height: 20rem;
    padding: 1rem;
    margin: 5% 5%;
    background-color: #eee;
    box-shadow: -10px -10px 35px #fff, 10px 10px 35px rgba(13,39,80,0.160784);
    box-sizing: border-box;
    border: 1px solid #eee;
    border-radius: 23px; 
}  
.swiper-icon{
    width: 5rem;
    align-self: center;
    margin-bottom: 1rem;
    margin-top: 1rem;
}  
.swiper-title {
    font-size: 17px;
    font-weight: bold;
    line-height: 1.6;
    text-align: center;
    letter-spacing: .2px;
    margin-bottom: 0.5rem;
    color: #3238C4;
}
.swiper-subtitle {
    font-size: 17px;
    font-weight: 400;
    line-height: 1.6;
    text-align: center;
    letter-spacing: .2px;
    margin-bottom: 1rem;
    color: #1D1D1E;
}
.custom-swiper-buttons{
    position: relative;
}
.swiper-button-next, .swiper-button-prev{
    color: #3238c4;
    position: absolute;
    top: 50%;
    transform: translateY(185px);
}
.swiper-button-next{
    right: 8rem;
}
.swiper-button-prev{
    left: 8rem;
}
.swiper-pagination {
    position: absolute;
    --swiper-theme-color: #3238c4;
}
.swiper-pagination-bullet {
    width: 5px;
    height: 5px;
}


@media only screen and (max-width: 768px){
    .swiper-page{padding-bottom: 2rem;}
    .wrap-swiper-content{padding: 0rem 0rem; margin: 0rem;}
    .swiper-title-content{font-size: 23px; margin: 0 2rem 2rem 2rem;}
    .swiper-subtitle-content{font-size: 16px; margin: 0 2.5rem 0 2.5rem;}
    .mySwiper {margin: 0rem 0rem 1rem 0rem;}
    .swiper-card{width: 70%;min-height: 24rem; padding: 1rem; margin: 2% 2%;}
    .swiper-icon{width: 5rem; margin-bottom: 1rem;}
    .swiper-title{font-size: 16px;}
    .swiper-subtitle{font-size: 15px;}
    .custom-swiper-buttons{display: none;}
    .swiper-button-next, .swiper-button-prev{display: none;}
    .swiper-pagination-bullet {width: 3px; height: 3px;
    }
}
@media only screen and (min-width: 769px) and (max-width: 1024px){
    .wrap-swiper-content{padding: 0rem 0rem 6rem 0rem;}
    .swiper-title-content{font-size: 36px; margin: 0rem 6rem 2rem 6rem;}
    .swiper-subtitle-content{font-size: 16px; margin: 0rem 6rem 1rem 6rem;}
    .mySwiper {margin: 0rem 0rem 2rem 0rem;}
    .swiper-card{width: 50%;min-height: 20rem; padding: 2rem; margin: 2% 2%;}
    .swiper-icon{width: 5rem; margin-bottom: 1rem;}
    .swiper-title{font-size: 16px;}
    .swiper-subtitle{font-size: 15px;}
}

/*tablet landscape*/
@media only screen and (min-width: 1024px) and (max-width: 1366px) and (min-height: 600px) and (max-height: 1024px){
    .wrap-swiper-content{padding: 2rem 0rem; margin: 2rem 0rem 0rem 0rem}

    .swiper-title-content{font-size: 32px; margin: 0 2rem 1rem 2rem;}
    .swiper-subtitle-content{font-size: 16px; margin: 0 2rem 2rem 2rem;}

    .mySwiper{margin: 0rem 5rem 2rem 5rem;}
    .swiper-button-next {right: 2rem;}
    .swiper-button-prev {left: 2rem;}

    .swiper-icon{width: 5rem; margin-bottom: 1rem;}
    .swiper-title{font-size: 16px;}
    .swiper-subtitle{font-size: 15px;}

}

@media only screen and (min-width: 1396px) and (max-width: 1705px) and (min-height: 632px) and (max-height: 772px){
    .swiper-page{padding-bottom: 2rem;}

    .swiper-title-content{font-size: 36px; margin: 0 2rem 1rem 2rem;}
    .swiper-subtitle-content{margin: 0 2rem 3rem 2rem;}

    .mySwiper{margin: 0 10rem 2rem 10rem;}
}


/*imagen MENTTUM*/
img.menttum{width: 100%;}





.wrap-search{
    display: none;
}

.wrap-buttons.consultas{
    display: none;

}

.wrap-buttons.consultas.visible{
    display: flex;
}

.wrap-search.visible{
    display: flex;
    flex-direction: column;
    justify-content: space-between;
}


.wrap-buttons.hidden{
    display: none;
}

.wrap-search-buttons{
    display: flex;
    flex-direction: row;
}

/* .wrap-search-buttons *{
    flex: 0 0 calc(50% - 20px);
} */

.item-button.search.grey-lineal{
    width: 100%;
    margin-bottom: 1rem;
    margin-right: 1rem;
}


.item-button.search-back{
    display: inline-flex;
    font-size: 13px;
    font-weight: bold;
    line-height: 1.6;
    border-radius: 28px;
    padding: 0.7rem;
    align-items: center;
    white-space: nowrap;
    color: #3238C4;

}

.item-button.search-back:hover{
    text-decoration: underline;
}

img.search-back{
    width: 10%;
    margin-right: 1rem;
}

.button-container {
	display: flex;
	justify-content: space-between;
	margin-top: 2rem;
}

#search-back {
	margin-right: auto;
}

#search-btn {
	margin-left: auto;
}
</style>


// WEBPACK FOOTER //
// src/components/public/PatientsLandingSwiper.vue